import {
  getCatalogPath,
  pathAddToCart,
  getCartList,
  pathRemoveToCart,
  getSearchCatalogList,
  putReceipt,
  pathCartItemsCounter,
  getOrderPath,
  putReceiptDetail,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { catalogActions } from "../reducers/catalog";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchCatalogList = (id) => {
  return (dispatch) => {
    return apiService
      .get(getCatalogPath(id))
      .then((response) => {
        dispatch(catalogActions.fetchCatalogList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchOrderList = (status) => {
  let statusName;
  switch (status) {
    case 0:
      statusName = "PENDING";
      break;
    case 1:
      statusName = "REJECTED";
      break;
    case 2:
      statusName = "APPROVED";
      break;
    default:
      statusName = "PENDING";
  }
  return (dispatch) => {
    return apiService
      .get(getOrderPath(statusName))
      .then((response) => {
        dispatch(catalogActions.fetchOrderList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchOrderDetailList = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(putReceiptDetail(id))
      .then((response) => {
        dispatch(catalogActions.fetchOrderDetailList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCreateReceipt = (formData, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(putReceipt(), formData)
      .then((response) => {
        toast.success(t("catalogInfo.receipt.success"), { theme: "colored" });
        dispatch(fetchCartItemsCounter());
        navigate("/");
      })
      .catch((err) => {
        handleError(err);
        throw err;
      });
  };
};

export const fetchSearchCatalogList = (search) => {
  return (dispatch) => {
    return apiService
      .get(getSearchCatalogList(search))
      .then((response) => {
        const items = {
          products: response.data,
        };

        dispatch(catalogActions.fetchCatalogList(items));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCartList = () => {
  return (dispatch) => {
    return apiService
      .get(getCartList())
      .then((response) => {
        dispatch(catalogActions.fetchCartList([]));
        dispatch(catalogActions.fetchCartList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchAddToCart = (item) => {
  return (dispatch) => {
    return apiService
      .post(pathAddToCart(), item)
      .then((response) => {
        dispatch(fetchCartItemsCounter());
        toast.success(t("catalogInfo.addToCart.success"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchAddQty = (item) => {
  return (dispatch) => {
    return apiService
      .post(pathAddToCart(), item)
      .then((response) => {
        dispatch(fetchCartList());
        toast.success(t("catalogInfo.addQty.success"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRemoveQty = (item, type) => {
  return (dispatch) => {
    return apiService
      .post(pathRemoveToCart(), item)
      .then((response) => {
        if (type !== "remove") dispatch(fetchCartItemsCounter());
        dispatch(fetchCartList());
        const message =
          type === "remove"
            ? t("catalogInfo.removeQty.success")
            : t("catalogInfo.removeItem.success");
        toast.success(message, {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCartItemsCounter = () => {
  return (dispatch) => {
    return apiService
      .get(pathCartItemsCounter())
      .then((response) => {
        dispatch(catalogActions.fetchCartTotalCounterItems(response.data.size));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
